import React, { FunctionComponent } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { CustomInput } from "../../../CustomInput";
import { ISectionProps } from "../ISectionProps";
import { ILeadPerfectionDataState } from "../../IState";
import { useNewInput } from "../../new-input.hook";
import { NewInputDialog } from "../NewInputDialog";
import { Button } from "../../../Button";

export const LeadPerfectionData: React.FunctionComponent<
  ISectionProps<ILeadPerfectionDataState>
> = (props) => {
  const { data, onChange } = props;

  const { isNewInputDialogOpen, toggleNewInputDialog } = useNewInput();

  return (
    <Box mt={1} ml={2}>
      <Typography
        sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 18, mb: 1 }}
      >
        LeadPerfection
      </Typography>
      <Box mt={2} display="flex" alignItems="center" flexWrap="wrap" gap={1}>
        <CustomInput
          width={220}
          height={35}
          label={{ text: "LP URL", color: "rgba(0, 0, 0, 0.8)" }}
          name="lpurl"
          value={data.lpurl}
          onChange={onChange}
        />
        <CustomInput
          width={220}
          height={35}
          label={{ text: "LP Product", color: "rgba(0, 0, 0, 0.8)" }}
          name="lpProduct"
          value={data.lpProduct}
          onChange={onChange}
        />
        <CustomInput
          width={220}
          height={35}
          label={{ text: "LP Source", color: "rgba(0, 0, 0, 0.8)" }}
          name="lpSource"
          value={data.lpSource}
          onChange={onChange}
        />
        <CustomInput
          width={220}
          height={35}
          label={{ text: "LP SubSource ID", color: "rgba(0, 0, 0, 0.8)" }}
          name="lpSubsourceID"
          value={data.lpSubsourceID}
          onChange={onChange}
        />
        {props.fields.map((field, index) => {
          const objName = Object.keys(field)[0] as keyof typeof field;

          return (
            <CustomInput
              width={220}
              height={35}
              label={{ text: objName.toString() }}
              name={objName.toString()}
              value={field[objName]}
              onChange={(event) =>
                props.onChangeField(
                  event as React.ChangeEvent<HTMLInputElement>,
                  index
                )
              }
            />
          );
        })}
      </Box>
      <Box mt={2}>
        <Button
          label="Add new field"
          width={120}
          height={35}
          onClick={toggleNewInputDialog}
        />
      </Box>
      <NewInputDialog
        open={isNewInputDialogOpen}
        onClose={toggleNewInputDialog}
        onClick={(name, value) => {
          props.onAdd(name, value);
          toggleNewInputDialog();
        }}
      />
    </Box>
  );
};
